<template>
  <v-container class="news">
    <v-card flat color="transparent">
      <div class="d-flex justify-space-between align-center mb-4">
        <div>
          <v-card-title class="white--text text-h5 font-weight-bold"> News verwalten</v-card-title>
          <v-card-subtitle class="white--text"> Verwalte hier News</v-card-subtitle>
        </div>
        <v-btn color="primary" class="mr-md-4" @click="addNews">
          <v-icon left>mdi-plus</v-icon>
          Neue News
        </v-btn>
      </div>

      <div v-if="sortedNews.active.length > 0 || sortedNews.upcoming.length > 0">
        <div class="section-title">Aktuell & Geplant</div>
        <v-row>
          <v-col v-for="item in [...sortedNews.active, ...sortedNews.upcoming]" :key="item._id" cols="12" sm="6" md="4">
            <v-card dark @click="editNews(item)" class="item-card d-flex flex-column" min-height="350" hover>
              <div class="status-indicator" :class="item.status.colorClass">
                <v-icon small color="white">{{ item.status.icon }}</v-icon>
                <span class="ml-1 font-weight-bold">{{ item.status.text }}</span>
              </div>
              <v-img v-if="item.foto" :src="'/img/news/' + item.foto" height="150"></v-img>
              <div v-else class="grey darken-3 d-flex align-center justify-center" style="height: 150px">
                <v-icon size="50" color="grey">mdi-image-off-outline</v-icon>
              </div>
              <v-card-title class="pt-4">{{ trimLength(item.titel, 40) }}</v-card-title>
              <v-card-text class="white--text font-weight-light flex-grow-1">
                <v-chip v-for="studioId in item.studios" :key="studioId" small class="ma-1">{{ getStudioById(studioId) }}</v-chip>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-subtitle class="caption text-center pa-2">
                <v-icon small>mdi-calendar-range</v-icon>
                {{ formatDate(item.von) }} - {{ formatDate(item.bis) }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="sortedNews.past.length > 0" class="mt-10">
        <div class="section-title">Archiv</div>
        <v-row>
          <v-col v-for="item in paginatedArchive" :key="item._id" cols="12" sm="6" md="4">
            <v-card dark @click="editNews(item)" class="item-card is-archived d-flex flex-column" min-height="350" hover>
              <div class="status-indicator is-past">
                <v-icon small color="white">mdi-archive-outline</v-icon>
                <span class="ml-1 font-weight-bold">Archiviert</span>
              </div>
              <v-img v-if="item.foto" :src="'/img/news/' + item.foto" height="150"></v-img>
              <div v-else class="grey darken-3 d-flex align-center justify-center" style="height: 150px">
                <v-icon size="50" color="grey">mdi-image-off-outline</v-icon>
              </div>
              <v-card-title class="pt-4">{{ trimLength(item.titel, 40) }}</v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-pagination v-if="archivePageCount > 1" v-model="archivePage" :length="archivePageCount" class="mt-4" dark></v-pagination>
      </div>
      <v-alert v-if="!news || news.length === 0" type="info" class="mt-4" text dark>
        Es sind noch keine News erstellt worden. Klicke auf "Neue News", um loszulegen.
      </v-alert>
    </v-card>

    <v-dialog v-model="newsDialog" max-width="900px" persistent>
      <v-card dark v-if="editNewsItem" class="mx-auto">
        <v-card-title class="text-h5">News {{ editNewsItem._id ? "bearbeiten" : "erstellen" }}</v-card-title>
        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col cols="12" md="7">
                <v-text-field v-model="editNewsItem.titel" label="Titel" outlined></v-text-field>
                <v-checkbox v-model="editNewsItem.showTitle" label="Titel in der News anzeigen"></v-checkbox>
                <vue-editor :editorToolbar="customToolbar" v-model="editNewsItem.inhalt"></vue-editor>
              </v-col>
              <v-col cols="12" md="5">
                <slim-cropper :key="editNewsItem.foto" style="width: 100%" :options="slimOptionsExercise">
                  <img v-if="editNewsItem.foto" :src="'/img/news/' + editNewsItem.foto" alt="" />
                  <input type="file" accept="image/*" />
                </slim-cropper>
                <v-card-subtitle class="text-center">Format: 1:1 (800x800)</v-card-subtitle>
                <v-divider class="my-4"></v-divider>
                <v-date-picker v-model="dates" locale="de-DE" range no-title dark></v-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editNewsItem.studios"
                  :items="studios"
                  item-text="name"
                  item-value="_id"
                  label="Für welche Studios?"
                  multiple
                  chips
                  outlined></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="newsDialog = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="saveNews" :disabled="!isFormValid">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "../../../api"
import { VueEditor } from "vue2-editor"
import Slim from "../../../plugins/slimImage/slim/slim.vue"

export default {
  components: { VueEditor, "slim-cropper": Slim },
  data() {
    return {
      newsDialog: false,
      news: [],
      editNewsItem: null,
      dates: [],
      studios: [],
      archivePage: 1,
      archiveItemsPerPage: 8, // Angepasst, da "Add Card" weg ist
      slimOptionsExercise: {
        ratio: "1:1",
        initialImage: "/img/einmalig/imageUploadPlaceholder.jpg",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        label: "Bild hochladen",
        service: this.uploadPicture,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["link"]],
    }
  },
  computed: {
    sortedNews() {
      const categories = { active: [], upcoming: [], past: [] }
      if (!this.news) return categories

      // Sort by 'from' date descending to show newest first
      const sortedByDate = [...this.news].sort((a, b) => b.von - a.von)

      sortedByDate.forEach((item) => {
        const now = this.$moment()
        const from = this.$moment.unix(item.von)
        const to = this.$moment.unix(item.bis)

        let status
        if (now.isAfter(to)) {
          status = "past"
        } else if (now.isBefore(from)) {
          status = "upcoming"
        } else {
          status = "active"
        }

        const statusDetails = this.getStatusDetails(status, from)
        categories[status].push({ ...item, status: statusDetails })
      })
      return categories
    },
    paginatedArchive() {
      const start = (this.archivePage - 1) * this.archiveItemsPerPage
      const end = start + this.archiveItemsPerPage
      return this.sortedNews.past.slice(start, end)
    },
    archivePageCount() {
      return Math.ceil(this.sortedNews.past.length / this.archiveItemsPerPage)
    },
    isFormValid() {
      if (!this.editNewsItem) return false
      const { titel, studios, von, bis } = this.editNewsItem
      return titel && titel.length > 2 && studios && studios.length > 0 && von && bis
    },
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      try {
        this.news = await api.getAllNews()
        this.studios = await api.fetchStudios()
        this.$emit("finishedloading")
      } catch (e) {
        this.$toast.error("Fehler beim Laden der Daten.")
      }
    },
    getStatusDetails(status, from) {
      const now = this.$moment()
      switch (status) {
        case "active":
          return { text: "Aktiv", icon: "mdi-broadcast", colorClass: "is-visible" }
        case "upcoming":
          const diff = from.diff(now, "days") + 1
          return { text: `Startet in ${diff} Tag(en)`, icon: "mdi-clock-start", colorClass: "is-upcoming" }
        default:
          return { text: "Archiviert", icon: "mdi-archive-outline", colorClass: "is-past" }
      }
    },
    getStudioById(studioId) {
      const studio = this.studios.find((s) => s._id === studioId)
      return studio ? studio.name : "N/A"
    },
    addNews() {
      this.dates = []
      this.editNewsItem = {
        _id: null,
        titel: "",
        inhalt: "",
        foto: null,
        von: null,
        bis: null,
        showTitle: true,
        studios: [],
      }
      this.newsDialog = true
    },
    editNews(item) {
      this.editNewsItem = JSON.parse(JSON.stringify(item))
      this.dates = [this.$moment.unix(this.editNewsItem.von).format("YYYY-MM-DD"), this.$moment.unix(this.editNewsItem.bis).format("YYYY-MM-DD")]
      this.newsDialog = true
    },
    async saveNews() {
      if (!this.isFormValid) {
        this.$toast.error("Bitte fülle alle Felder aus (Titel, Studios, Datum).")
        return
      }
      try {
        await api.saveNews(this.editNewsItem)
        this.$toast.success("News erfolgreich gespeichert")
        this.newsDialog = false
        this.init()
      } catch (e) {
        this.$toast.error("Fehler beim Speichern der News")
      }
    },
    uploadPicture(formdata, progress, success, failure) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      api
        .uploadImage({ art: "news", formData })
        .then((data) => {
          if (data.status) {
            this.editNewsItem.foto = "uploads/" + data.name
            success(data)
          }
        })
        .catch((error) => failure(error))
    },
    trimLength(str, length) {
      if (!str) return ""
      return str.length > length ? str.substring(0, length) + "..." : str
    },
    formatDate(ts) {
      return this.$moment.unix(ts).format("DD.MM.YY")
    },
  },
  watch: {
    dates(newDates) {
      if (!this.editNewsItem || !newDates || newDates.length < 2) return
      // FIX: Create a copy of the array before sorting to prevent infinite loop
      const sortedDates = [...newDates].sort((a, b) => new Date(a) - new Date(b))

      const newVon = this.$moment(sortedDates[0]).startOf("day").unix()
      const newBis = this.$moment(sortedDates[1]).endOf("day").unix()

      // Only update if values have actually changed to prevent watcher re-triggering
      if (this.editNewsItem.von !== newVon || this.editNewsItem.bis !== newBis) {
        this.editNewsItem.von = newVon
        this.editNewsItem.bis = newBis
      }
    },
  },
}
</script>

<style scoped>
.item-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 12px !important;
  background: linear-gradient(145deg, #2a2a2a, #1e1e1e);
  box-shadow: 5px 5px 15px #1c1c1c, -5px -5px 15px #2e2e2e;
  border: 2px solid transparent;
  position: relative;
  height: 100%;
}
.item-card:hover {
  transform: translateY(-5px);
  border-color: var(--v-primary-base);
}
.item-card.is-archived {
  opacity: 0.7;
}
.status-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  color: white;
  z-index: 1;
}
.status-indicator.is-visible {
  background-color: #4caf50;
}
.status-indicator.is-upcoming {
  background-color: #ff9800;
}
.status-indicator.is-past {
  background-color: #616161;
}

.section-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  margin-bottom: 16px;
  margin-top: 16px;
  padding-left: 8px;
  border-left: 4px solid var(--v-primary-base);
}
</style>
